// English for the invoices area. Key: exact Macedonian text passed to t().
const en = {
  'Молиме внесете број на фактура и клиент': 'Please enter an invoice number and a client',
  'Број на испратница е задолжителен': 'Delivery note number is required',
  'Број на фактура е задолжителен': 'Invoice number is required',
  'Изберете примач': 'Select a recipient',
  'Изберете клиент': 'Select a client',
  'Изберете добавувач': 'Select a supplier',
  'Датумот е задолжителен': 'Date is required',
  'Најмалку една ставка е задолжителна': 'At least one item is required',
  'Грешка: {status} {statusText}': 'Error: {status} {statusText}',
  'Испратница зачувана!': 'Delivery note saved!',
  'Испратница #{number} е успешно зачувана!': 'Delivery note #{number} saved successfully!',
  'Креиран е нов партнер „{name}“.': 'New partner "{name}" was created.',
  'Ве молиме најавете се за да зачувате документи.': 'Please log in to save documents.',
  'Фактура ажурирана!': 'Invoice updated!',
  'Фактура зачувана!': 'Invoice saved!',
  'Фактура #{number} е успешно ажурирана!': 'Invoice #{number} updated successfully!',
  'Фактура #{number} е успешно зачувана!': 'Invoice #{number} saved successfully!',
  'Грешка при зачувување': 'Error saving',
  'Преглед не е достапен за влезни фактури': 'Preview is not available for incoming invoices',
  'Испратница': 'Delivery note',
  'Фактура': 'Invoice',
  'Тип на фактура': 'Invoice type',
  'Излезна': 'Outgoing',
  'Фактура за клиент': 'Invoice to a client',
  'Влезна': 'Incoming',
  'Фактура од добавувач': 'Invoice from a supplier',
  'Од (Ваша фирма)': 'From (your company)',
  'Од (Добавувач)': 'From (supplier)',
  'Избери или внеси нова компанија...': 'Select or enter a new company...',
  'До (Клиент)': 'To (client)',
  'До (Ваша фирма)': 'To (your company)',
  'До': 'To',
  'Број на испратница': 'Delivery note number',
  'Број на фактура': 'Invoice number',
  'Транспорт детали': 'Transport details',
  'Адреса на испорака': 'Delivery address',
  'Адреса': 'Address',
  'Возило / Рег. број': 'Vehicle / Reg. number',
  'Подигнал': 'Picked up by',
  'Име': 'Name',
  'Датум на креирање': 'Creation date',
  'Датум на испратница': 'Delivery note date',
  'Ставки': 'Items',
  'Слободна ставка — не се зачувува како производ': 'Free-text line — not saved as a product',
  'Додади услуга': 'Add service',
  'Назив': 'Name',
  'Кол.': 'Qty',
  'Единица': 'Unit',
  'Услуга: слободен опис, не се зачувува како производ. Кликни за производ.': 'Service: free-text description, not saved as a product. Click for product.',
  'Производ од листата. Кликни за слободна услуга.': 'Product from the list. Click for a free-text service.',
  'Услуга': 'Service',
  'Производ': 'Product',
  'Опис на услуга...': 'Service description...',
  'Назив на ставка...': 'Item name...',
  'Цена:': 'Price:',
  'пар': 'pair',
  'ком': 'pcs',
  'кг': 'kg',
  'л': 'l',
  'м': 'm',
  'Избриши ставка': 'Delete item',
  'Без ДДВ:': 'Excl. VAT:',
  'ДДВ (18%):': 'VAT (18%):',
  'Вкупно:': 'Total:',
  'Поврзани фактури': 'Related invoices',
  'Додади фактура': 'Add invoice',
  'Нова фактура': 'New invoice',
  'Клиент': 'Client',
  'Назив на клиент...': 'Client name...',
  'Забелешки': 'Notes',
  'Додатни информации за исправката...': 'Additional information about the correction...',
  'Нема повразани фактури. Кликни „Додади фактура“ за да поврзеш.': 'No related invoices. Click "Add invoice" to link one.',
  'Грешка при валидација': 'Validation error',
  'Ве молиме поправете ги следните полиња пред да продолжите:': 'Please fix the following fields before continuing:',
  'Додатни информации...': 'Additional information...',
  'Ве молиме најавете се за да ги видите фактурите.': 'Please log in to view invoices.',
  'Неуспешно вчитување на податоците за фактурата': 'Failed to load invoice data',
  'Грешка при вчитување на фактурата': 'Error loading invoice',
  'Не може да се вчитаат податоците за фактурата.': 'Could not load the invoice data.',
  'Ве молиме најавете се за да го промените статусот.': 'Please log in to change the status.',
  'Неуспешно ажурирање на статусот: {status}': 'Failed to update status: {status}',
  'Статусот е ажуриран': 'Status updated',
  'Статусот на фактурата е променет во {status}.': 'Invoice status changed to {status}.',
  'Грешка при ажурирање на статусот': 'Error updating status',
  'Не може да се ажурира статусот на фактурата.': 'Could not update the invoice status.',
  'Невалиден износ': 'Invalid amount',
  'Ве молиме внесете валиден износ на плаќање.': 'Please enter a valid payment amount.',
  'Ве молиме најавете се за да додавате плаќања.': 'Please log in to add payments.',
  'Плаќањето е додадено': 'Payment added',
  'Плаќање од {amount} ден е успешно додадено.': 'Payment of {amount} ден added successfully.',
  'Неуспешно додавање на плаќањето': 'Failed to add payment',
  'Грешка при додавање на плаќањето': 'Error adding payment',
  'Не може да се додаде плаќањето.': 'Could not add the payment.',
  'Дали сте сигурни дека сакате да го избришете ова плаќање?': 'Are you sure you want to delete this payment?',
  'Ве молиме најавете се за да бришете плаќања.': 'Please log in to delete payments.',
  'Плаќањето е избришано': 'Payment deleted',
  'Плаќањето е успешно избришано.': 'Payment deleted successfully.',
  'Неуспешно бришење на плаќањето': 'Failed to delete payment',
  'Грешка при бришење на плаќањето': 'Error deleting payment',
  'Не може да се избрише плаќањето.': 'Could not delete the payment.',
  'Ве молиме најавете се за да уредувате плаќања.': 'Please log in to edit payments.',
  'Плаќањето е ажурирано': 'Payment updated',
  'Плаќањето е успешно ажурирано.': 'Payment updated successfully.',
  'Неуспешно ажурирање на плаќањето': 'Failed to update payment',
  'Грешка при ажурирање на плаќањето': 'Error updating payment',
  'Не може да се ажурира плаќањето.': 'Could not update the payment.',
  'Ве молиме најавете се за да бришете фактури.': 'Please log in to delete invoices.',
  'Фактурата е избришана': 'Invoice deleted',
  'Фактурата е успешно избришана.': 'Invoice deleted successfully.',
  'Неуспешно бришење на фактурата': 'Failed to delete invoice',
  'Грешка при бришење на фактурата': 'Error deleting invoice',
  'Не може да се избрише фактурата.': 'Could not delete the invoice.',
  'Вчитување на фактура...': 'Loading invoice...',
  'Фактурата не е пронајдена': 'Invoice not found',
  'Назад кон листата': 'Back to list',
  'Уреди фактура': 'Edit invoice',
  'Нема достапен PDF': 'No PDF available',
  'Сè уште не е генериран PDF за оваа фактура.': 'No PDF has been generated for this invoice yet.',
  'Преглед PDF': 'View PDF',
  'Статус:': 'Status:',
  'Статус на плаќање:': 'Payment status:',
  'Платена': 'Paid',
  'Делумно платена': 'Partially paid',
  'Неплатена': 'Unpaid',
  'Фактура #{number}': 'Invoice #{number}',
  'Датум:': 'Date:',
  'Преостанато за плаќање:': 'Remaining to pay:',
  'Целосно платена': 'Fully paid',
  'Примач:': 'Recipient:',
  'Телефон:': 'Phone:',
  'Е-пошта:': 'Email:',
  'Ставки:': 'Items:',
  'ДДВ %': 'VAT %',
  'Меѓузбир:': 'Subtotal:',
  'ДДВ:': 'VAT:',
  'Платено:': 'Paid:',
  'Преостанато:': 'Remaining:',
  'Плаќања': 'Payments',
  'Додади плаќање': 'Add payment',
  'Износ (ден)': 'Amount (ден)',
  'Датум на плаќање': 'Payment date',
  'Начин на плаќање': 'Payment method',
  'Банкарски трансфер': 'Bank transfer',
  'Готовина': 'Cash',
  'Чек': 'Check',
  'Картичка': 'Card',
  'Друго': 'Other',
  'Белешка (опционално)': 'Note (optional)',
  'Белешка за плаќањето...': 'Payment note...',
  'Уреди плаќање': 'Edit payment',
  'Избриши плаќање': 'Delete payment',
  'Нема евидентирани плаќања': 'No payments recorded',
  'Додадете плаќање за да го следите статусот на фактурата': 'Add a payment to track the invoice status',
  'Вкупно платено:': 'Total paid:',
  'Избриши фактура': 'Delete invoice',
  'Дали сте сигурни дека сакате да ја избришете оваа фактура? Оваа акција не може да се врати.': 'Are you sure you want to delete this invoice? This action cannot be undone.',
  'Потребна е најава. Ве молиме најавете се.': 'Authentication required. Please log in.',
  'Неуспешно вчитување на фактурите: {status} {statusText}': 'Failed to load invoices: {status} {statusText}',
  'Нема достапен PDF за оваа фактура': 'No PDF available for this invoice',
  'Примач': 'Recipient',
  'Датум на фактура': 'Invoice date',
  'Рок за плаќање': 'Payment due',
  'Вкупна сума': 'Total amount',
  'Завршена': 'Complete',
  'Нацрт': 'Draft',
  'Креирана на': 'Created on',
  'Акции': 'Actions',
  'Прегледај PDF': 'View PDF',
  'Погледни детали и плаќања': 'View details and payments',
  'Вчитување на фактури...': 'Loading invoices...',
  'Грешка при вчитување на фактурите': 'Error loading invoices',
  'Обиди се повторно': 'Try again',
  'Број на фактура...': 'Invoice number...',
  'Партнер': 'Partner',
  'Сите партнери': 'All partners',
  'Избриши ги сите филтери': 'Clear all filters',
  'Примени филтери': 'Apply filters',
  'Филтрирај': 'Filter',
  'Фактури': 'Invoices',
  'Избери колони': 'Choose columns',
  'Колони': 'Columns',
  'Прикажи колони': 'Show columns',
  'Освежи ја листата': 'Refresh the list',
  'Освежи': 'Refresh',
  'Експортирај ги фактурите во CSV': 'Export invoices to CSV',
  'Експорт': 'Export',
  'Нема пронајдени фактури': 'No invoices found',
  'Вчитување на ставки...': 'Loading items...',
  'Назив на производ': 'Product name',
  'Непознат производ': 'Unknown product',
  'Нема пронајдени ставки за оваа фактура': 'No items found for this invoice',
  'Ве молиме најавете се за да ги видите плаќањата.': 'Please log in to view payments.',
  'Неуспешно вчитување на плаќањата': 'Failed to load payments',
  'Грешка при вчитување на плаќањата': 'Error loading payments',
  'Не може да се вчитаат податоците за плаќањата.': 'Could not load the payment data.',
  'Износ': 'Amount',
  'Белешка': 'Note',
  'Погледни фактура': 'View invoice',
  'Вчитување на плаќања...': 'Loading payments...',
  'Вкупен износ': 'Total amount',
  'Вкупно плаќања': 'Total payments',
  'Овој месец': 'This month',
  'Фактура, партнер, начин...': 'Invoice, partner, method...',
  'Експортирај ги плаќањата во CSV': 'Export payments to CSV',
  'Нема пронајдени плаќања': 'No payments found',
  'Последни фактури': 'Latest invoices',
  'Види ги сите': 'View all',
  'Без партнер': 'No partner',
  'Креирајте ја Вашата прва фактура за да започнете': 'Create your first invoice to get started',
  'Последни плаќања': 'Latest payments',
  'Плаќањата ќе се прикажат тука кога ќе бидат евидентирани': 'Payments will appear here once they are recorded',
  'Брзи акции': 'Quick actions',
  'Креирајте нова фактура': 'Create a new invoice',
  'Нова испратница': 'New delivery note',
  'Креирајте испратница': 'Create a delivery note',
  'Управувај со продукти': 'Manage products',
  'Додадете или уредете производи': 'Add or edit products',
  'Преглед на фактури': 'Invoice overview',
  'Прегледајте ги сите фактури': 'Browse all invoices',
  'Фактурата не е пронајдена.': 'Invoice not found.',
  'Грешка: {status}': 'Error: {status}',
  'Фактурата не може да се вчита.': 'The invoice could not be loaded.',
  'Вчитување на фактурата...': 'Loading invoice...',
  'Технички детали:': 'Technical details:',
};

export default en;
